import { createNullableContext } from '../nullableContext';
import { PersistentStorageApi } from './types';

export const PersistentStorageApiContext =
  createNullableContext<PersistentStorageApi>();
